module.exports = __webpack_public_path__ + "static/media/left.94c9260c.svg";